import React, { useEffect, useState } from 'react';
import Pagination from '../components/GroupInfo/Pagination';
import WebhookFromModal from '../components/Settings/Webhook Settings/WebhookFromModal';
import WebhookList from '../components/Settings/Webhook Settings/WebhookList';
import Toaster from '../components/Toaster';
// import featherPlusImg from '../assets/images/Icon feather-plus.png';
// import featherDownloadImg from '../assets/images/Icon feather-download.png';
import PlusIMgDark from '../assets/images/plusDark.png';
import downloadDark from '../assets/images/downloadDark.png';
import { useDispatch, useSelector } from 'react-redux';
import { getWebhookSettings } from '../redux/actions/webhookSettings';
import Loader from '../components/Loader';
import { sampleCSVdownload } from '../services/extraServices';

const WebhookSettings = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const [curpage, setCurpage] = useState(1);

	const webhookSettings = useSelector((state) => state.webhookSettings);
	const { loading, webhooks, page, totalPage, successDelete, success } =
		webhookSettings;

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getWebhookSettings(curpage));
	}, [dispatch, curpage]);

	useEffect(() => {
		if (successDelete || success) dispatch(getWebhookSettings(curpage));
	}, [successDelete, success, dispatch, curpage]);

	return (
		<>
			{loading ? (
				<Loader />
			) : (
				<div className='container webHookWrapers'>
					{/* Modal Overlay Sectionis activate by Toogling the className activate. */}
					<div className={`overlayMain ${modalOpen ? 'activate' : ''}`}></div>
					<div className='tabHeadingText'>
						<h4 className='tabsHeadings'>Webhook Settings</h4>
            {webhooks && webhooks.length > 0 && (
						<div className='actionBttons'>
							<button
								className='firstBtn gmNewBtn tabBtns'
								onClick={() => setModalOpen(true)}
							>
								<img src={PlusIMgDark} className='tabBtnImgs' alt='' /> Add
								Webhook
							</button>
							<button className='secondBtn gmNewBtn tabBtns' onClick={sampleCSVdownload}>
								<img src={downloadDark} className='tabBtnImgs' alt='' />{' '}
								Download Sample CSV
							</button>
						</div>
            )}
					</div>
					<WebhookList webhooks={webhooks} setModalOpen={setModalOpen} sampleCSVdownload={sampleCSVdownload} />
					<WebhookFromModal setModalOpen={setModalOpen} modalOpen={modalOpen} />
					<Pagination
						setCurpage={setCurpage}
						totalPage={totalPage}
						page={page}
					/>
					<Toaster />
				</div>
			)}
		</>
	);
};

export default WebhookSettings;
